<content>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error':showError}">
        <div class="info">{{'global.infoRequired' | translate}}</div>
        <div class="entry-5-modal">
            <label>{{'gestionLicencias.licencia.etiquetador' | translate}} *</label>
            <app-filterable-list class="no-margin" [itemsList]="etiquetadores" [selectedItem]="newEditForm.get('etiquetador')" [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div *ngIf="licenciaId" class="entry-5-modal">
            <label>{{'gestionLicencias.licencia.numActivaciones' | translate}} *</label>
            <!-- Estilo para iPad -->
            <input type="number" formControlName="numeroActivaciones" style="margin: unset;">
        </div>
        <div class="entry-5-modal">
            <label>{{'gestionLicencias.licencia.activacionesMax' | translate}} *</label>
            <input type="number" formControlName="numeroActivacionesMax" style="margin: unset;">
        </div>
        <div class="entry-5-modal">
            <label>{{'gestionLicencias.licencia.movimientosMax' | translate}} *</label>
            <input type="number" formControlName="numeroMovimientosMax" style="margin: unset;">
        </div>
        <div class="entry-5-modal calendar">
            <label>{{'gestionLicencias.licencia.fechaExpiracion' | translate}}</label>
            <input [matDatepicker]="fechaExpiracion" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaExpiracion"
                (click)="fechaExpiracion.open()" style="margin: unset;">
            <mat-datepicker #fechaExpiracion></mat-datepicker>
        </div>
        <div class="entry-5-modal">
            <label>{{'gestionLicencias.licencia.diasExpiracion' | translate}}</label>
            <input type="number" formControlName="diasAvisoExpiracion" style="margin: unset;">
        </div>
        <div class="entry-5-modal">
            <label>{{'gestionLicencias.licencia.periodoGracia' | translate}}</label>
            <input type="number" formControlName="diasPeriodoGracia" style="margin: unset;">
        </div>
        <div class="entry-5-modal">
            <label>{{'gestionLicencias.licencia.idioma' | translate}} *</label>
            <app-filterable-list class="no-margin short-list" [itemsList]="idiomas" [selectedItem]="newEditForm.get('idioma')" [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div class="entry-5-modal">
            <label>{{'gestionLicencias.licencia.temporizador' | translate}} *</label>
            <app-filterable-list class="no-margin short-list" [itemsList]="confirmacionesPendientes" [selectedItem]="newEditForm.get('temporizadorConfirmacionesPendientes')" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-5-modal">
            <label>{{'gestionLicencias.licencia.actualizarVersion' | translate}} * <i class="fas fa-info-circle"
                title="{{'titles.proximaVez' | translate}}"></i></label>
                <app-filterable-list class="no-margin short-list" [itemsList]="versionesSW" [selectedItem]="newEditForm.get('versionPendienteActualizar')" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-5-modal">
            <label>{{'gestionLicencias.licencia.aplicacion.titulo' | translate}} *</label>
            <app-filterable-list class="no-margin" [itemsList]="aplicacion" [selectedItem]="newEditForm.get('aplicacion')" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-5-modal alignment-start" *ngIf="licenciaId">
          <input type="checkbox" id="editHabilitada" formControlName="habilitada">
          <label for="editHabilitada">{{'gestionLicencias.licencia.habilitada' | translate}}</label>
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{licenciaId ? ('global.actualizar' | translate) : ('global.insertar' | translate)}}</button>
</footer>
<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event"></app-toast>
